import React, { FC } from 'react';

import { A, Article, CONTACT_URL, Document, Ol, P, Ul } from './Layout';

const Terms: FC = () => (
  <Document
    title="利用規約"
    enactedOn="2026年9月11日"
    lead="この利用規約（以下「本規約」といいます。）は、チェック運営（以下「運営者」といいます。）が提供するアプリケーション「CHECK」（以下「本アプリ」といいます。）の利用条件を定めるものです。ご利用になる皆さま（以下「ユーザー」といいます。）には、本規約に従って本アプリをご利用いただきます。"
  >
    <Article title="第1条（適用）">
      <Ol
        items={[
          '本規約は、本アプリの利用に関する運営者とユーザーとの間の一切の関係に適用されるものとします。',
          '運営者は本アプリに関し、本規約のほか、ご利用にあたってのルール等、各種の定め（以下「個別規定」といいます。）をすることがあります。これら個別規定はその名称のいかんに関わらず、本規約の一部を構成するものとします。',
          '本規約の規定が前項の個別規定の規定と矛盾する場合には、個別規定において特段の定めなき限り、個別規定の規定が優先されるものとします。',
        ]}
      />
    </Article>

    <Article title="第2条（定義）">
      <P>本規約において、次の各用語はそれぞれ次の意味を有するものとします。</P>
      <Ul
        items={[
          'ペア：本アプリ上でふたりのユーザーが相互に結びついた状態、およびその単位をいいます。',
          'ペアコード：ペアを組むために発行される6桁の符号をいいます。',
          'アイディア：ペアが本アプリ上に登録する、ふたりでやりたいことの記録をいいます。',
          'チェキ：アイディアを叶えた際の写真をもとに本アプリが生成する画像をいいます。',
          'Premium：本アプリの有料プランをいいます。',
          '投稿データ：ユーザーが本アプリに登録または送信した文章、絵文字、写真その他一切の情報をいいます。',
        ]}
      />
    </Article>

    <Article title="第3条（利用登録）">
      <Ol
        items={[
          '本アプリの利用には、Appleアカウントによるサインイン、および名前・プロフィール写真・性別・生まれ年の登録が必要です。',
          'ユーザーは、登録する情報を正確かつ最新の内容に保つものとします。',
          '13歳未満の方は本アプリを利用できません。未成年の方は、親権者その他の法定代理人の同意を得たうえでご利用ください。',
          'アカウントはユーザー本人のみが利用できるものとし、第三者に譲渡、貸与または共有することはできません。',
          'ユーザーのAppleアカウントまたは端末を通じて行われた操作は、当該ユーザー本人による操作とみなします。',
          'アカウントが第三者によって使用されたことにより生じた損害は、運営者に故意または重大な過失がある場合を除き、運営者は責任を負いません。',
        ]}
      />
    </Article>

    <Article title="第4条（ペア）">
      <Ol
        items={[
          'ペアを組めるのは2名までです。ペアコードは発行から10分間のみ有効で、期限が過ぎた場合は再度発行してください。',
          '本アプリは、ふたりでひとつのリストを共有するものです。ペアの一方が登録したアイディアおよび写真は、他方のユーザーが閲覧、編集および削除することができます。ユーザーは、相手方に見せてよい情報のみを登録するものとします。',
          'ペアを解除した場合、ユーザーは新しい空のリストに移り、解除前のアイディアおよびチェキを閲覧できなくなります。残しておきたい写真は、解除前に端末へ保存してください。',
          '運営者は、前項により閲覧できなくなったデータを復旧する義務を負いません。',
        ]}
      />
    </Article>

    <Article title="第5条（投稿データ）">
      <Ol
        items={[
          '投稿データに関する著作権その他の権利は、ユーザーまたは正当な権利者に帰属します。本規約のいずれの規定も、運営者に投稿データの権利を移転させるものではありません。',
          '運営者は、本アプリの提供、保守、障害の調査および品質改善に必要な範囲に限り、投稿データを利用することができるものとします。運営者は、広告その他の目的で投稿データの内容を第三者に開示しません。',
          'ユーザーは、投稿データについて、これを登録するために必要な権利を有していること、および第三者の権利を侵害していないことを保証するものとします。',
          '投稿データのバックアップは、ユーザーご自身の責任で行ってください。',
        ]}
      />
    </Article>

    <Article title="第6条（禁止事項）">
      <P>ユーザーは、本アプリの利用にあたり、次の行為をしてはなりません。</P>
      <Ul
        items={[
          '法令または公序良俗に違反する行為',
          '犯罪行為に関連する行為',
          '運営者、ペアの相手方その他の第三者の知的財産権、肖像権、プライバシー、名誉その他の権利または利益を侵害する行為',
          '本人の同意なく第三者の個人情報または写真を登録する行為',
          '他者に対する誹謗中傷、脅迫、嫌がらせその他の迷惑行為',
          'わいせつ、児童ポルノまたは児童虐待に当たる情報を登録する行為',
          '本アプリの運営を妨害し、またはサーバーもしくはネットワークに過度の負荷をかける行為',
          '本アプリを不正に改変し、逆コンパイルし、または権限のない方法で利用する行為',
          '虚偽の情報を登録する行為、および他人になりすます行為',
          '本アプリを営業、宣伝、勧誘その他本来の目的以外に利用する行為',
          'その他、運営者が不適切と合理的に判断する行為',
        ]}
      />
      <P>
        運営者は、ユーザーが前項に違反したと判断した場合、事前の通知なく、投稿データの削除、本アプリの利用停止またはアカウントの削除をすることができるものとします。
      </P>
    </Article>

    <Article title="第7条（Premium）">
      <Ol
        items={[
          'Premiumは、App Storeを通じて購入する自動更新のサブスクリプションです。価格および更新期間は、購入時にApp Store上で表示される内容によります。',
          '期間満了の24時間以上前に解約されない限り、同一の期間および料金で自動的に更新されます。',
          '解約は、iOSの「設定」内のサブスクリプションの管理画面から行ってください。本アプリからの退会やペアの解除では課金は停止しません。',
          'ペアのいずれか一方がPremiumである間は、ペアの双方について無料プランの上限が適用されません。',
          'Premiumは購入したユーザー本人に帰属します。ペアを解除した場合も、Premiumは購入したユーザーに残ります。',
          '支払済みの料金は、Appleが定める場合を除き返金されません。返金の可否および手続は、Appleの定めに従います。',
        ]}
      />
    </Article>

    <Article title="第8条（無料プランの制限）">
      <P>
        無料プランでは、まだ叶えていないアイディアを5件まで登録でき、チェキはペア合計で1ヶ月あたり3枚まで作成できます。運営者は、これらの数値を、本アプリ上での表示その他の適切な方法によりあらかじめ周知したうえで変更することがあります。
      </P>
    </Article>

    <Article title="第9条（データの削除）">
      <Ol
        items={[
          'アイディアを削除すると、当該アイディアに紐づく写真およびチェキもあわせて削除され、元に戻すことはできません。',
          '退会すると、アカウント、および当該ユーザーが登録したアイディア・写真・チェキはすべて削除されます。ペアの相手方が本アプリを継続して利用している場合であっても、退会したユーザーが登録したアイディアは、そこに相手方が追加した写真とともに削除されます。',
          '運営者は、前各項による削除について、復旧の義務を負いません。',
        ]}
      />
    </Article>

    <Article title="第10条（本アプリの変更・中断・終了）">
      <Ol
        items={[
          '運営者は、ユーザーへの事前の通知なく、本アプリの内容を変更し、または一部の機能を終了することができます。',
          '運営者は、システムの保守、障害、天災その他やむを得ない事由がある場合、ユーザーへの事前の通知なく本アプリの提供を中断することができます。',
          '運営者は、本アプリの提供を終了する場合、本アプリ上での表示その他の適切な方法によりあらかじめユーザーに周知します。',
        ]}
      />
    </Article>

    <Article title="第11条（免責事項）">
      <Ol
        items={[
          '運営者は、本アプリに事実上または法律上の瑕疵（安全性、正確性、確実性、有用性、特定の目的への適合性を含みます。）が存在しないことを保証しません。',
          '運営者は、本アプリの利用によりユーザーに生じた損害について、運営者に故意または重大な過失がある場合を除き、責任を負いません。',
          '前項にかかわらず、ユーザーが消費者契約法上の消費者に当たる場合、運営者は、運営者の軽過失による債務不履行または不法行為に基づく損害について、損害が生じた時点からさかのぼって12ヶ月間にユーザーが本アプリに関して支払った金額を上限として、通常生ずべき損害の範囲に限り責任を負うものとします。',
          '運営者は、ユーザー間またはユーザーと第三者との間で生じた紛争について、責任を負いません。',
        ]}
      />
    </Article>

    <Article title="第12条（権利帰属）">
      <P>
        本アプリおよび本アプリに関する著作権、商標権その他の知的財産権は、運営者または正当な権利者に帰属します。本規約に基づく本アプリの利用許諾は、これらの権利の使用許諾を意味するものではありません。
      </P>
    </Article>

    <Article title="第13条（本規約の変更）">
      <P>
        運営者は、本規約の変更がユーザーの一般の利益に適合する場合、または変更が契約をした目的に反せず、かつ、変更の必要性、変更後の内容の相当性その他の事情に照らして合理的である場合には、民法第548条の4の定めに従い、本規約を変更することができます。この場合、運営者は、変更後の本規約の効力発生時期および内容を、本アプリ上での表示その他の適切な方法によりあらかじめ周知します。
      </P>
    </Article>

    <Article title="第14条（連絡・通知）">
      <P>
        運営者からユーザーへの連絡または通知は、本アプリ内での表示、プッシュ通知または登録されたメールアドレス宛の送信により行うものとします。
      </P>
    </Article>

    <Article title="第15条（準拠法および管轄）">
      <P>
        本規約の準拠法は日本法とします。本アプリまたは本規約に関して運営者とユーザーとの間に紛争が生じた場合には、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
      </P>
    </Article>

    <Article title="第16条（お問い合わせ）">
      <P>
        本規約または本アプリに関するお問い合わせは、
        <A href={CONTACT_URL}>お問い合わせフォーム</A>
        よりお願いいたします。
      </P>
    </Article>
  </Document>
);

export default Terms;
